module.exports = __webpack_public_path__ + "static/media/mahi-mahi.e17b4e58.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/mahi-mahi.png
// module id = 321
// module chunks = 0